import { Configuration } from '@checklistfacil/shared/util/environment';

export const endpoints = {
  listAchievements: (environment: Configuration) =>
    `${environment.spaApiUrl}/achievements`,
  companyNumbers: (environment: Configuration) =>
    `${environment.spaApiUrl}/usage-summary`,
};
